import { Reducer } from 'redux';
import { ArcgisState, ArcgisActionTypes } from 'types';

const initialState: ArcgisState = {};

const reducer: Reducer<ArcgisState> = (state = initialState, action: any) => {
  switch (action.type) {
    case ArcgisActionTypes.GET_ARCGIS_PWD_START: {
      const { accessCredentials } = state;
      return {
        ...state,
        accessCredentials: {
          ...accessCredentials,
          processing: 'getting',
          username: undefined,
          password: undefined
        }
      };
    }
    case ArcgisActionTypes.GET_ARCGIS_PWD_SUCCESS: {
      const { accessCredentials } = state;

      return {
        ...state,
        accessCredentials: {
          ...accessCredentials,
          processing: undefined,
          username: action.payload.username
        }
      };
    }
    case ArcgisActionTypes.GET_ARCGIS_PWD_FAILURE: {
      const { accessCredentials } = state;
      return {
        ...state,
        accessCredentials: {
          ...accessCredentials,
          processing: undefined,
          error: action.payload
        }
      };
    }
    case ArcgisActionTypes.ADD_ARCGIS_PWD_START: {
      const { accessCredentials } = state;
      return {
        ...state,
        accessCredentials: {
          ...accessCredentials,
          processing: 'adding'
        }
      };
    }
    case ArcgisActionTypes.ADD_ARCGIS_PWD_SUCCESS: {
      const { accessCredentials } = state;
      return {
        ...state,
        accessCredentials: {
          ...accessCredentials,
          processing: undefined,
          username: action.payload.username,
          password: action.payload.password
        }
      };
    }
    case ArcgisActionTypes.ADD_ARCGIS_PWD_FAILURE: {
      const { accessCredentials } = state;
      return {
        ...state,
        accessCredentials: {
          ...accessCredentials,
          processing: undefined,
          error: action.payload
        }
      };
    }
    case ArcgisActionTypes.DELETE_ARCGIS_PWD_START: {
      const { accessCredentials } = state;
      return {
        ...state,
        accessCredentials: {
          ...accessCredentials,
          processing: 'deleting'
        }
      };
    }
    case ArcgisActionTypes.DELETE_ARCGIS_PWD_SUCCESS: {
      return {
        ...state,
        accessCredentials: undefined
      };
    }
    case ArcgisActionTypes.DELETE_ARCGIS_PWD_FAILURE: {
      const { accessCredentials } = state;
      return {
        ...state,
        accessCredentials: {
          ...accessCredentials,
          processing: undefined,
          error: action.payload
        }
      };
    }
    case ArcgisActionTypes.RESET_ARCGIS_PWD: {
      if (state?.accessCredentials) {
        delete state.accessCredentials;
      }

      return state;
    }
    default: {
      return state;
    }
  }
};

export { reducer as ArcgisReducer };
